import {useLocation} from 'react-router-dom'
// import {Tabs} from 'antd'
import { Tabs } from '../V2'
import './TabsPanel.scss'
import {Chat} from 'modules/chat'
import {useRouteTabs, useOpen} from 'common/hooks'
import {Panel, Circle, Modal} from 'common/components'
import {Tab} from 'common/types'

interface TabsPanelProps {
  isChatUpdates?: boolean
  title: string
  img: string
  path: string
  tabs: Tab[]
  tag?: string
}

export default function TabsPanel({
  isChatUpdates,
  title,
  img,
  path,
  tabs,
  tag,
}: TabsPanelProps) {
  const {hash} = useLocation()
  const [isChatOpen, handleChatOpen, handleChatClose] = useOpen(
    hash === '#chat'
  )
  const [activeTab, handleTabsChange] = useRouteTabs(path, handleChatOpen)

  const items = [
    ...tabs.map(({badge, label, ...tab}) => ({
      ...tab,
      label: (
        <div>
          {label}
          {badge && <Circle className="TabsPanel-Badge" ripple color={badge} />}
        </div>
      ),
    })),
    // {
    //   key: 'chat',
    //   label: (
    //     <div className="TabsPanel-Icon">
    //       <ChatIcon />
    //       {isChatUpdates && <Circle ripple color="brown" />}
    //     </div>
    //   ),
    // },
  ]

  return (
    <>
      <div className="TabsPanel">
        <Panel tag={tag} img={img} title={title} />
        <Tabs
          size="small"
          className="TabsPanel-Tab"
          activeKey={activeTab}
          items={items}
          onChange={handleTabsChange}
        />
      </div>
      <Modal
        title={`Chat ‘${title}’`}
        wrapClassName="TabsPanel-Chat"
        width={692}
        open={isChatOpen}
        onCancel={handleChatClose}
      >
        <Chat isRequest={path.includes('requests')} />
      </Modal>
    </>
  )
}
